// extracted by mini-css-extract-plugin
export default {"hideTooltip":"P_-z","fadeIn":"Q_-z","delay":"R_-z","recommendedSizeTooltip":"S_-z"};